<div class="mb-dialog mb-dialog-custom">
  <mb-dialog-body>
    <div class="mb-dialog-custom__body">
      <div class="left" [class.left--experts]="isExperts">
        <div class="ctn-header-gallery">
          <span class="title">
            <span class="text" [innerHtml]="dialogData.hotelStatic.name"></span>
            <mb-stars-rating [rating]="dialogData.hotelStatic.stars"></mb-stars-rating>
          </span>
          <mb-icon (click)="closeDialog()" [ngClass]="'close'" icon="close"></mb-icon>
        </div>
        <slider
          class="gallery-slider"
          [items]="images"
          [itemsCant]="1"
          [showMiniGallery]="true"
          [position]="dialogData.position"
        >
        </slider>
      </div>
    </div>
  </mb-dialog-body>
</div>